import { createRoot } from 'react-dom/client'
import LoginPage from '../components/LoginPage'
import '../styles/global.css'
import '../styles/login.css'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('login-root')
  if (container) {
    // Get data from data attributes
    const alert = container.dataset.alert
    const notice = container.dataset.notice
    const emailAddress = container.dataset.emailAddress

    // Render the login page
    const root = createRoot(container)
    root.render(
      <LoginPage
        alert={alert}
        notice={notice}
        emailAddress={emailAddress}
      />
    )
  }
})
